<template>
  <el-dialog
    :title="$locale('sideMenu.film.moviTicketMaster') + actionText"
    :visible.sync="isOpen"
    :show-close="true"
    class="egl-dialog-elm movie-ticket-dialog"
    width="1000px"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :append-to-body="true"
  >
      <el-form :disabled="dialogDisable" :model="form" ref="detailForm" label-position="top">
        <div class="form-module">
          <div class="form-module-tit">{{ $locale("global.basicInfo") }}</div>
          <!-- 名前 -->
          <el-form-item :label="$locale('global.name')" prop="name" :rules="mandatoryField">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.1')"
              v-model="form.name"
              maxlength="100"
              :disabled="fieldsDisabled.name"
            ></el-input>
          </el-form-item>
          <!-- 取引先 -->
          <el-form-item :label="$locale('accountReceivable.client')" prop="clientId" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <!-- <remote-select
              type="client"
              :isMultiple="false"
              v-model="form.clientId"
              :formValue.sync="form.clientId"
              :actionType="$parent.$parent.$options.name === 'movie-ticket-master' ? 
               : ($route.path.indexOf('create') > -1 ? 'create' : 'edit')"
            ></remote-select> -->
            <RemoteSelectV2
              ref="selectV2Client"
              type="client"
              :list="comClientList"
              v-model="form.clientId"
              :isMultiple="false"
              :formValue.sync="form.clientId"
              :fields="['id', 'name']"
              @setList="arr => comClientList = arr"
            />
          </el-form-item>
          <!-- 表示順（昇順） -->
          <el-form-item :label="$locale('couponLib.displayOrder_asce')" prop="sort" v-if="authority.isOtherType">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.3')"
              v-model.number="form.sort"
              :disabled="fieldsDisabled.sort"
              maxlength="5"
            ></el-input>
          </el-form-item>
          <!-- 興行収入計上金額 -->
          <el-form-item :label="$locale('couponLib.amountOfBoxOfficeRevenue')" prop="boxOfficeAmount" :rules="mandatoryField">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.3')"
              v-model="form.boxOfficeAmount"
              maxlength="20"
              @change="evt => currencyFieldHandle({ value: evt, type: 'boxOfficeAmount' })"
              :disabled="fieldsDisabled.boxOfficeAmount"
            ></el-input>
          </el-form-item>
          <!-- 販売金額 -->
          <el-form-item :label="$locale('movie.ticketMaster.sellAmount')" prop="sellAmount" v-if="!authority.isOtherType">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.4')"
              v-model="form.sellAmount"
              maxlength="20"
              @change="evt => currencyFieldHandle({ value: evt, type: 'sellAmount' })"
              :disabled="fieldsDisabled.sellAmount"
            ></el-input>
          </el-form-item>
          <!-- チケット印字金額 -->
          <!-- <el-form-item :label="$locale('couponLib.ticketPrintAmount')" prop="actualAmount" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.5')"
              v-model="form.actualAmount"
              maxlength="20"
              @change="evt => currencyFieldHandle({ value: evt, type: 'actualAmount' })"
              :disabled="fieldsDisabled.actualAmount"
            ></el-input>
          </el-form-item> -->
          <!-- 手数料 -->
          <el-form-item :label="$locale('global.fee')" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item prop="feeCircle">
                  <el-input
                    :placeholder="$locale('movie.ticketList.ph.6')"
                    v-model.number="form.feeCircle"
                    maxlength="20"
                    :disabled="fieldsDisabled.feeCircle"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="feeCircleType">
                  <el-select
                    v-model="form.feeCircleType"
                    :disabled="fieldsDisabled.feeCircleType"
                  >
                    <el-option
                      v-for="option in currencyList"
                      :label="option.label"
                      :value="option.value"
                      :key="`currencyList_${option.value}`"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- メガネ代 -->
          <el-form-item :label="$locale('movie.ticketMaster.glassesFee')" prop="glassesAmount" :rules="mandatoryField" v-if="!authority.isOtherType">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.5')"
              v-model="form.glassesAmount"
              maxlength="20"
              :disabled="fieldsDisabled.glassesAmount"
            ></el-input>
          </el-form-item>
          <!-- 券種コード -->
          <el-form-item :label="$locale('movie.codeOfMulberry')" prop="ticketingCode">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.7')"
              v-model="form.ticketingCode"
              maxlength="2"
              :disabled="fieldsDisabled.ticketingCode"
            ></el-input>
          </el-form-item>
          <!-- 利用人数 -->
          <el-form-item :label="$locale('movie.numOfUsers')" prop="useNumber">
            <el-input
              :placeholder="$locale('movie.ticketList.ph.8')"
              v-model.number="form.useNumber"
              maxlength="1"
              :disabled="fieldsDisabled.useNumber"
            ></el-input>
          </el-form-item>
          <!-- ムビチケ連携区分 -->
          <el-form-item :label="$locale('movie.mvtk.category')" prop="category">
            <el-select
              v-model="form.category"
            >
              <el-option
                label="全国共通券"
                value="01"
              ></el-option>
              <el-option
                label="劇場券"
                value="02"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 専用券（スクリーン規格） -->
          <el-form-item :label="$locale('movie.specialTicket')" prop="usableVersion1" :rules="mandatoryField" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-select v-model="form.usableVersion1" :disabled="fieldsDisabled.usableVersion1">
              <el-option
                v-for="option in versionList"
                :label="option.name"
                :value="option.id"
                :key="option.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <div class="alertMsg-block" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-form-item :label="$locale('rules.alertMessage')">
              <el-row :gutter="10" v-for="(msg, msgIdx) in form.checkMessages" :key="`alertMsg${msgIdx}`">
                <el-col :span="5">
                  <el-form-item
                    :prop="`checkMessages[${msgIdx}].deviceType`"
                    :rules="[{
                      required: msg.checkMsg !== '',
                      message: $locale('form.mandatoryField'),
                      trigger: 'change',
                    }]"
                  >
                    <el-select v-model="msg.deviceType" :disabled="fieldsDisabled.checkMessages" clearable>
                      <el-option
                        v-for="option in deviceList"
                        :label="option.label"
                        :value="option.value"
                        :key="`deviceList_${option.value}`"
                        :disabled="isPlatformDisabled(option.value, msgIdx)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item :prop="`checkMessages[${msgIdx}].checkMsg`">
                    <el-input
                      :placeholder="$locale('form.plsEnterMsg')"
                      v-model="msg.checkMsg"
                      :disabled="fieldsDisabled.checkMessages"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <CtrlBtns
                    :fieldData="form.checkMessages"
                    :index="msgIdx"
                    :authority="{
                      ...authority.checkMessagesAuth,
                      add: authority.checkMessagesAuth.add && form.checkMessages.length < deviceList.length
                    }"
                    :disabled="dialogDisable"
                    @clickAction="operation => ticketListingCtrl({ operation, msgIdx })"
                  ></CtrlBtns>
                </el-col>
              </el-row>
            </el-form-item>
          </div>

          <el-form-item :label="$locale('movie.coordination')" prop="mobilize`" class="w120" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <BoolSelect :value.sync="form.mobilize" :disabled="fieldsDisabled.mobilize"></BoolSelect>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <template v-if="!dialogDisable">
              <el-button @click="close_fn()" class="egl-btn-white">
                {{ $locale("global.cancel") }}
              </el-button>
              <el-button @click="save_fn()" class="egl-btn-yellow">
                {{ $locale("global.confirm") }}
              </el-button>
            </template>
            <el-button @click="close_fn()" class="egl-btn-yellow" v-else>
              {{ $locale("global.close") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
  </el-dialog>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { toThousands, adminTypeList } from "@/utils/common";
import  {
  // mandatoryField,
  ticketUtilizeObj,
  ticketCoordinationObj,
  currencyList,
  deviceList,
} from "@/assets/js/movieStatic";
import CtrlBtns from "./CtrlBtns";
import BoolSelect from "./BoolSelect.vue";
import RemoteSelect from "@/components/common/RemoteSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import Emitter from "element-ui/lib/mixins/emitter";
import { getClientListService } from "@/helpers/service/api/common";

export default {
  inject: [ "clientList" ],
  name: "MovieTicketDialog",
  mixins: [ Emitter ],
  data() {
    return {
      visible: false,
      dialogDisable: false,
      actionText: "",
      form: this.createForm(),
      mandatoryField: [ {
        required: this.$parent.$parent.$options.name === "movie-ticket-master",
        message: this.$locale("form.mandatoryField"),
        trigger: ["change", "blur"],
      } ],
      currencyList,
      deviceList,
      adminTypeList,
      comClientList: [],
    };
  },
  computed: {
    injectClientList() {
      return this.clientList();
    },
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        this.close_fn();
      }
    },
    fieldsDisabled() {
      let resultObj = {};
      Object.keys(tranfResData(ticketUtilizeObj)).forEach(key => {
        resultObj[key] = !this.authority.editFields.includes(key);
      });
      return resultObj;
    },
  },
  methods: {
    isPlatformDisabled(platformValue, currentIdx) {
      return this.form.checkMessages.some((msg, idx) => idx !== currentIdx && msg.deviceType === platformValue);
    },
    close_fn() {
      this.$emit("closeFn");
    },
    save_fn() {
      
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          this.dispatch("movieDetail", "pushList", this.form);
          this.$emit("returnMsg", this.form);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          return false;
        }
      });
    },
    createForm() {
      return {
        ...tranfResData(ticketUtilizeObj)
      };
    },
    ticketListingCtrl({
      msgIdx = 0, // index
      operation, // "ADD" | "DEL"
    }) {
      const _op = operation ? operation.toUpperCase() : null;
      if (!_op) {
        // eslint-disable-next-line no-console
        console.warn("[ticketListingCtrl]: 'operation' should be one of \"ADD\" | \"DEL\" ");
        return;
      } else if (_op === "DEL" && typeof msgIdx === undefined) {
        // eslint-disable-next-line no-console
        console.warn("[ticketListingCtrl]: 'index' is mandatory while delete some item in array");
        return;
      }

      let targetArray = this.form.checkMessages;
      let newArray = tranfResData(ticketCoordinationObj);

      if (_op === "ADD") {
        if (targetArray.length >= this.deviceList.length) { return; }
        targetArray.push({ ...newArray });
      } else if (_op === "DEL") {
        targetArray.splice(msgIdx, 1);
      }
    },
    currencyFieldHandle({
      value,
      type,
    }) {
      this.form[type] = toThousands(parseInt(value.replace(/,/g, "")));
    },
  },
  props: {
    action: {
      type: String,
      default: ""
    },
    formData: {
      required: true,
      type: Object,
    },
    // distributorOptions: {
    //   required: true,
    //   type: Array,
    // },
    versionList: {
      required: true,
      type: Array,
    },
    authority: {
      type: Object,
      default: () => ({
        type: null,
        edit: false,
        add: false,
        del: false,
        editFields: [],
      }),
    },
  },
  watch: {
    action() {
      let visible = false;
      let actionText = "";
      let dialogDisable = false;
      let form = this.action === "create" ? this.createForm() : { ...this.createForm(), ...this.formData };
      // checkMessages长度为0时候 插入一条数据
      form.checkMessages = form.checkMessages.length === 0 ? [ tranfResData(ticketCoordinationObj) ] : form.checkMessages;
      if (this.action != "") {
        visible = true;
      } else {
        visible = false;
      }
      getClientListService({
        ids: this.form.clientId,
        page: 0,
        pageSize: 9999,
        field: ["id", "name"]
      }).then(res => {
        if (res.data && res.data.data.length > 0) {
          this.comClientList = this.$_.uniqBy(res.data.data.concat(this.injectClientList), "id");
        }
      });
      this.comClientList = this.injectClientList;
      if (this.action == "create") {
        actionText = this.$locale("global.create");
      } else if (this.action == "edit") {
        actionText = this.$locale("global.edit");
      } else {
        dialogDisable = true;
      }
      this.actionText = actionText;
      this.dialogDisable = dialogDisable;
      this.form = form;
      this.visible = visible;
    },
  },
  components: {
    CtrlBtns,
    BoolSelect,
    RemoteSelect,
    RemoteSelectV2
  }
};
</script>
<style scoped lang="less">
  .movie-ticket-dialog {
    .alertMsg-block {
      .el-row + .el-row {
        margin-top: 20px;
      }

      .ctrl-btns {
        > a {
          margin-top: 20px;
        }
      }
    }
  }
</style>
